<!-- This component supports FDK Link component instead of Anchor tag because of better compatibility -->
<template>
  <component
    :is="isButton ? 'button' : 'fdk-link'"
    :link="isButton ? undefined : href"
    :target="isButton ? undefined : '_blank'"
    :class="mergedClasses"
    :disabled="isDisabled"
    @click="handleClick"
    v-bind="$attrs"
  >
    <slot></slot>
  </component>
</template>

<script>
  import { classMerge } from "@/utils/utils"

  export default {
    name: "JMLink",
    props: {
      href: {
        type: String,
        default: "",
        required: false, // href is optional for button type
      },
      type: {
        type: String,
        default: "link",
        validator: (value) => ["button", "link"].includes(value),
      },
      className: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isButton() {
        return this.type === "button"
      },
      isDisabled() {
        return this.isButton && this.disabled
      },
      baseClasses() {
        return "fe-inline-flex fe-items-center fe-cursor-pointer fe-text-body-s-link fe-text-primary-60 fe-bg-transparent fe-border-transparent fe-border-xxxs fe-no-underline hover:fe-text-primary-50 focus-visible:fe-outline-none focus-visible:fe-border-solid focus-visible:fe-border-xxxs focus-visible:fe-border-primary-60 focus-visible:fe-rounded-small"
      },
      disabledClasses() {
        return this.isDisabled
          ? "fe-text-primary-60 !fe-bg-transparent !fe-opacity-30"
          : ""
      },
      mergedClasses() {
        return classMerge(
          this.baseClasses,
          this.disabledClasses,
          this.className,
        )
      },
    },
    methods: {
      handleClick(event) {
        // Prevent default action for anchor tags
        if (this.type === "link") {
          event.preventDefault()
        }
        this.$emit("click", event)
      },
    },
  }
</script>
